import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { FwButtonComponent } from '@flywheel-io/vision';

@Component({
  host: {'test-id': 'operation-cancel-popover-body'},
  selector: 'operation-cancel-popover-body',
  templateUrl: './operation-cancel-popover-body.component.html',
  styleUrls: ['./operation-cancel-popover-body.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    FwButtonComponent,
  ],
})
export class OperationCancelPopoverBodyComponent {
  readonly title = input<string>();
  readonly text = input<string>();
  readonly submitTitle = input<string>();
  readonly cancelTitle = input<string>();

  readonly submitClick = output<void>();
  readonly cancelClick = output<void>();
}
